import { createIntercom } from '@mathieustan/vue-intercom'

/**
 *
 * @param {Object} app
 * @param {string} appId
 */
export function installIntercom(app, appId) {
    app.use(createIntercom({ appId }))

    // Bubble should appear on open
    app.config.globalProperties.intercomModule = {
        show() {
            app.config.globalProperties.$intercom.show()
            const launcher = document.querySelector('.intercom-launcher-frame')
            if (launcher) {
                launcher.style.display = 'block'
            }
        },
    }
}

export function initIntercom(app, payload, hasSubscription) {
    app.$intercom.boot({
        user_hash: payload.operatorHash,
        user_id: payload.operator.id,
        name: `${payload.operator.first_name} ${payload.operator.last_name}`,
        email: payload.operator.email,
        created_at: payload.operator.joined_at,
        has_subscription: hasSubscription,
    })

    // Bubble should be hidden on close
    app.$intercom.callIntercom('onHide', () => {
        document.querySelector('.intercom-launcher-frame').style.display = 'none'
    })
}